<template>
 
    
    <TopNav />
    <SideBar />
    <Dashboard />
  
</template>

<script>
// @ is an alias to /src
import TopNav from '@/components/TopNav.vue'
import SideBar from '@/components/SideBar.vue'
import Dashboard from '@/components/DashBoard.vue'
import {mapState} from 'vuex'


export default {
  name: 'Home',
  components: {
    TopNav,
    SideBar,
    Dashboard
  },
  computed: mapState([
        'access_token', 'refresh_token']),
  created (){
    

  }
}
</script>
